var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsKurzatmigkeit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -1 23 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-kurzatmigkeit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medical-specialty-lungs",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.34199109,5.7405422 C1.50129738,7.93736701 0.194401606,13.1449517 0.00141699663,20.978327 C-0.0198412498,21.535042 0.198916706,22.0740953 0.602121464,22.4585552 C1.00532622,22.8430152 1.55417534,23.0358833 2.1092489,22.9881667 L7.97278129,22.3882146 C8.49986837,22.3263903 8.97902019,22.0524974 9.29976015,21.6296867 C9.62050011,21.206876 9.7551434,20.6716424 9.67264573,20.1473933 L9.14168807,16.5236823 C8.69505702,13.4752587 8.36441673,10.4131696 8.14976718,7.33741485 C8.11862043,6.68310058 7.75465144,6.09028484 7.18524408,5.76644455 C6.61583672,5.44260425 5.92027336,5.43282983 5.34199109,5.7405422 L5.34199109,5.7405422 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "11.5005 0 11.5005 8.49932219 3.00117777 14.9988039"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.83395186,
    y1: 12.8319767,
    x2: 4.00109803,
    y2: 10.9991228,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.992019,
    y1: 13.4759253,
    x2: 6.00093854,
    y2: 15.9987241,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "5.00101829 17.4986045 6.00093854 15.9987241 7.0008588 16.4986843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6590088,5.7405422 C21.5047021,7.94036677 22.8065983,13.1449517 22.998583,20.978327 C23.0198412,21.535042 22.8010833,22.0740953 22.3978785,22.4585552 C21.9946738,22.8430152 21.4458247,23.0358833 20.8907511,22.9881667 L15.0272187,22.3882146 C14.5001316,22.3263903 14.0209798,22.0524974 13.7002399,21.6296867 C13.3794999,21.206876 13.2448566,20.6716424 13.3273543,20.1473933 L13.8583119,16.5236823 C14.304943,13.4752587 14.6355833,10.4131696 14.8502328,7.33741485 C14.8812153,6.68280376 15.245327,6.0896765 15.8150348,5.76578064 C16.3847427,5.44188478 17.0806497,5.43235991 17.6590088,5.7405422 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5005,
    y1: 8.49932219,
    x2: 19.9998222,
    y2: 14.9988039,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.1670481,
    y1: 12.8319767,
    x2: 18.9999019,
    y2: 10.9991228,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.0089809,
    y1: 13.4759253,
    x2: 17.0000614,
    y2: 15.9987241,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "17.9999816 17.4986045 17.0000614 15.9987241 16.0001411 16.4986843"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsKurzatmigkeit);
export default __webpack_public_path__ + "static/media/icons-kurzatmigkeit.ebaa8bb6e282c0e2d08bbd222272562f.svg";
export { ForwardRef as ReactComponent };